<template>
  <v-sheet
    class="d-flex align-center"
    color="transparent"
    :height="height*0.9"
  >
    <v-container>
      <div v-show="show">
        <v-layout justify-center>
          <h1 class="fade-in">Illustration</h1>
        </v-layout>

        <div style="height: 20px;"/>

        <v-layout justify-center>
          <v-card 
            class="fade-in pa-10"
            color="transparent"
            elevation="0"
            width="900"
          >
            <v-img src="../../../images/illustration.png" max-height="500"/>
          </v-card>
        </v-layout>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
import windowSizeMixin from '../../../mixin/windowSizeMixin'

export default {
  mixins: [ windowSizeMixin ],
  props: {
    show: {
      require: true,
      type: Boolean,
      default: false,
    }
  },
  data: ()=>({
  }),
}
</script>

<style>
  @import '../../../styles/fade.css';
</style>